import { module } from 'angular';
import App from '../../../app';

class SCR0704Controller {
	
	constructor ($scope, $uibModalInstance, $timeout, httpService, utilService, codeService, gridService, popupService, data){
		this.$scope = $scope;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.codeService = codeService;
		this.data = data;
		this.codes = codeService.commonCodes;
		this.allMsgType = data.codes.MSG_TYPE;
		
		this.initWindow('100%', '100%');
		this.initText();
		
		this.$timeout(() => {
			this.initGridOption();
			this.getMsgDetailGridData()
		});
		
		$(window).on('resize.0704', this.resizeGrid.bind(this));
		
		this.$scope.$on('$destroy', () => {
			$(window).off('resize.0704');
		});	
	}
	
	initWindow(width, height){
		this.width = width;
		this.height = height;
		this.top = 100;
		this.left = 50;
		this.right = 50;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageMsg'));	
	}
	
	initGridOption(){
		this.detailGridView = new RealGridJS.GridView('msg-detail-grid');
		this.detailDataProvider = new RealGridJS.LocalDataProvider();
		this.detailGridView.setDataSource(this.detailDataProvider);		
		this.gridService.setDefaultSetting(this.detailGridView);
		this.detailGridView.setCheckBar({visible: false});
		this.detailGridView.setSelectOptions({style: 'block'});
		this.detailGridView.setEditOptions({editable: true});
		this.detailGridView.setDisplayOptions({vscrollBar: true, focusVisible: true, eachRowResizable: true, focusColor: '#aaa'}); 
		this.detailGridView.setFixedOptions({colCount: 8});
		this.detailGridView.setSortingOptions({enabled: false});
		
		this.detailDataProvider.setFields([
            {fieldName: "msgSeq", dataType: 'number'}, 
            {fieldName: "fldEngNm"}, 
    		{fieldName: "fldKorNm"}, {fieldName: "cfgDesc"}, {fieldName: "dataTypeNm"}, 
    		{fieldName: "msgLen", dataType: 'number'}, {fieldName: "decimalLen", dataType: 'number'}, {fieldName: "fldLvNo", dataType: 'number'}, 
            {fieldName: "childDtoNm"}, {fieldName: "arraySizeRefVal"}, {fieldName: "indsYn"}, 
            {fieldName: "basicVal"}, {fieldName: "privacyDscd"}, {fieldName: "replKey"}, 
            {fieldName: "encYn"}, {fieldName: "alignNm"}, {fieldName: "cdAttrNm"}, 
            {fieldName: "ioKey"}, {fieldName: "korInclYn"},  {fieldName: "fldRmk"},  
            {fieldName: "confirmMeta"}, 
            {fieldName: "extrnlMsgNoYn"}, {fieldName: "iso8583SpecNo"},  
            {fieldName: "iso8583FldCharSetCd"}, {fieldName: "iso8583VariableYn"},  
            {fieldName: "iso8583FldLenTypeCd"}, {fieldName: "iso8583LenFldLen"}, 
            {fieldName: "iso8583LenFldInclYn"}, {fieldName: "iso8583LenFldCopyYn"}, {fieldName: "iso8583TagVal"}, 
            {fieldName: "iso8583TrnsmsnDataLen"}, {fieldName: "extrnlSrchKeyYn"},{fieldName: "bizRspsCdYn"},  
            {fieldName: "fldUnqId"}, {fieldName: "parentFldNm"},
            {
            	fieldName: "ioKeyTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.codeService.getCodeValNm('IO_KEY', values[fieldNames.indexOf('ioKey')]);
            	}
    		},
    		{fieldName: "iso8583FldMaxLen"}, {fieldName: "fillerVal"},  
    		{fieldName: "formatType"}, {fieldName: "format"}
        ]);
		
		this.detailGridView.setColumns(this._getDefaultMsgDetailGridColumns());
		
		this.detailGridView.onShowTooltip = (grid, index, value) => {
			let tooltip = '<div class="rg-tooltip">' + value + '</div>';
			
			if(value.length > 50) {
				 tooltip = '<div class="rg-tooltip" style="width: 500px;">' + value + '</div>';
			}
			
			return tooltip;
		};
		
		this.detailGridView.onShowHeaderTooltip = (grid, index, value) => {
			let tooltip = '<div class="rg-tooltip">' + value + '</div>';
			
			if(value.length > 50) {
				 tooltip = '<div class="rg-tooltip" style="width: 500px;">' + value + '</div>';
			}
			
			return tooltip;
		};
	}
	
	_getDefaultMsgDetailGridColumns(){
		let columns = [
			{ 
				name: "msgSeq", fieldName: "msgSeq", header : { text: this.text.msgSeq, showTooltip: false } , 
				width: 33, styles: { textAlignment: 'center', textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "fldEngNm", fieldName: "fldEngNm", header : { text: this.text.fldEngNm, showTooltip: false }, 
				width: 105, styles: { textWrap: 'ellipse' },
				dynamicStyles: [				
					{ criteria: 'values["fldLvNo"] = 1', styles: {paddingLeft: '10px'} },
					{ criteria: 'values["fldLvNo"] = 2', styles: {paddingLeft: '20px'} },
					{ criteria: 'values["fldLvNo"] = 3', styles: {paddingLeft: '30px'} },
					{ criteria: 'values["fldLvNo"] = 4', styles: {paddingLeft: '40px'} },
					{ criteria: 'values["fldLvNo"] = 5', styles: {paddingLeft: '50px'} },
					{ criteria: 'values["fldLvNo"] = 6', styles: {paddingLeft: '60px'} }
				],
				editable: false
			},
			{
				name: "fldKorNm", fieldName: "fldKorNm", header : { text: this.text.fldKorNm, showTooltip: false }, 
				width: 105, styles: { textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "cfgDesc", fieldName: "cfgDesc", header : { text: this.text.cfgDesc, showTooltip: false }, 
				width: 90, styles: { textWrap: 'ellipse' },
				editable: false
			},
			this.gridService.getSelectionEditorColumn({ 
				name: "dataTypeNm", fieldName: "dataTypeNm", header : { text: this.text.dataType, showTooltip: false }, 
				width: 70, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.DATA_TYPE),
			{ 
				name: "msgLen", fieldName: "msgLen", header : { text: this.text.msgLen, showTooltip: false }, 
				width: 35, styles: { textAlignment: 'center', textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "decimalLen", fieldName: "decimalLen", header : { text: this.text.decimalLen, showTooltip: false }, 
				width: 40, styles: { textAlignment: 'center', textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "fldLvNo", fieldName: "fldLvNo", header : { text: this.text.fldLvNo, showTooltip: false }, 
				width: 40, styles: { textAlignment: 'center', textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "fldRmk", fieldName: "fldRmk", header : { text: this.text.fldRmk, showTooltip: false }, 
				width: 110, editable: false, styles: { textWrap: 'ellipse' },
				renderer: {
					showTooltip: true
				}
			},
			{ 
				name: "cdAttrNm", fieldName: "cdAttrNm", header : { text: this.text.cdAttrNm, showTooltip: false }, 
				width: 70, editable: false, styles: { textWrap: 'ellipse' },
				renderer: {
					showTooltip: true
				}
			},
			this.gridService.getSelectionEditorColumn({ 
				name: "indsYn", fieldName: "indsYn", header : { text: this.text.indsYn, showTooltip: false }, 
				width: 35, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.YN_CD),
			{ 
				name: "basicVal", fieldName: "basicVal", header : { text: this.text.basicVal, showTooltip: false }, 
				width: 45, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			},	
			this.gridService.getSelectionEditorColumn({ 
				name: "privacyDscd", fieldName: "privacyDscd", header : { text: this.text.privacyDscd, showTooltip: false }, 
				width: 60, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.PRIVACY_CD),
			this.gridService.getSelectionEditorColumn({ 
				name: "replKey", fieldName: "replKey", header : { text: this.text.replacedKey, showTooltip: false }, 
				width: 100, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.selectedMsg && this.selectedMsg.chlDscd === 'EXTERNAL' ?  this.codes.REPLACEKEY_EXT : this.codes.REPLACEKEY_INT),
			this.gridService.getSelectionEditorColumn({ 
				name: "encYn", fieldName: "encYn", header : { text: this.text.encYn, showTooltip: false }, 
				width: 70, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.YN_CD),
			this.gridService.getSelectionEditorColumn({ 
				name: "alignNm", fieldName: "alignNm", header : { text: this.text.alignNm, showTooltip: false }, 
				width: 40, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.ALIGN_CD, [{value: "NONE", label: " "}]),
			this.gridService.getSelectionEditorColumn({ 
				name: "ioKey", fieldName: "ioKey", header : { text: this.text.ioKey, showTooltip: false }, labelField: 'ioKeyTxt',
				width: 70, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.IO_KEY, [{value: "", label: ""}]),
			this.gridService.getSelectionEditorColumn({ 
				name: "korInclYn", fieldName: "korInclYn", header : { text: this.text.hangleIncludeYn, showTooltip: false }, 
				width: 80, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.YN_CD),
			{ 
				name: "childDtoNm", fieldName: "childDtoNm", 
				header : { text: this.text.childDtoNm }, 
				width: 138, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			},
			{ 
				name: "arraySizeRefVal", fieldName: "arraySizeRefVal", header : { text: this.text.arraySizeRefVal, showTooltip: false }, 
				width: 90, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false 
			}
		];
		
		
		columns.push(this.gridService.getSelectionEditorColumn({ 
			name: "fillerVal", fieldName: "fillerVal", header : { text: this.text.fillerVal, showTooltip: false }, 
			width: 40, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false ,
		}, this.codes.FILLER_CD, [{value: "", label: ""}]));
		
		columns.push({ 
			name: "confirmMeta", fieldName: "confirmMeta", header : { text: this.text.confirmMeta, showTooltip: false }, 
			width: 60, styles: { textAlignment: 'center', textWrap: 'ellipse' },
			dynamicStyles: [
				{
				criteria: 'value = "' + this.text.accord + '"',
				styles: {foreground: '#1fa67a'}
			},
			{
				criteria: 'value = "' + this.text.discord + '"',
				styles: {foreground: '#ff4526'}
			}],
			editable: false
		});
		
		if(this.data.trxDscd === 'BATCH'){
			columns.push(this.gridService.getSelectionEditorColumn({ 
				name: "formatType", fieldName: "formatType", header : { text: this.text.formatType, showTooltip: false }, 
				width: 60, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false ,
			}, this.codes.FORMAT_TYPE, [{value: "", label: ""}]));
			
			columns.push({ 
				name: "format", fieldName: "format", header : { text: this.text.format, showTooltip: false }, 
				width: 60, styles: { textWrap: 'ellipse' },
				renderer: {
					showTooltip: true
				}
			});
		}
		
		if(!_.isEmpty(this.data.msgDscd)){
			switch(this.data.msgDscd){
			case 'ISOH':
				columns.push(...[
					this.gridService.getSelectionEditorColumn({ 
						name: "extrnlMsgNoYn", fieldName: "extrnlMsgNoYn", header : { text: this.text.extrnlMsgNoYn, showTooltip: false } , 
						width: 80, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD),
					{ 
						name: "iso8583SpecNo", fieldName: "iso8583SpecNo", header : { text: this.text.specNo, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' }, editable: false
					},
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583FldCharSetCd", fieldName: "iso8583FldCharSetCd", header : { text: this.text.fldCharSetCd, showTooltip: false } , 
						width: 80, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.ISO_FLD_CHARSET_CD),
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583VariableYn", fieldName: "iso8583VariableYn", header : { text: this.text.variableYn, showTooltip: false } , 
						width: 60, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD),
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583FldLenTypeCd", fieldName: "iso8583FldLenTypeCd", header : { text: this.text.fldLenTypeCd, showTooltip: false } , 
						width: 100, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.ISO_FLD_LEN_TYPE_CD),
					{ 
						name: "iso8583LenFldLen", fieldName: "iso8583LenFldLen", header : { text: this.text.fldLenLenCd, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' }, editable: false 
					},
					{ 
						name: "iso8583TrnsmsnDataLen", fieldName: "iso8583TrnsmsnDataLen", header : { text: this.text.trnsmsnDataLen, showTooltip: false } , 
						width: 100, styles: { textAlignment: 'center' },
						editable: false
					},
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583LenFldInclYn", fieldName: "iso8583LenFldInclYn", header : { text: this.text.lenFldInclYn, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD),
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583LenFldCopyYn", fieldName: "iso8583LenFldCopyYn", header : { text: this.text.lenFldCopyYn, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD),
					{ 
						name: "iso8583TagVal", fieldName: "iso8583TagVal", header : { text: this.text.tagVal, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' } 
					},
					{ 
						name: "iso8583FldMaxLen", fieldName: "iso8583FldMaxLen", header : { text: this.text.fldMaxLen, showTooltip: false } , 
						width: 100, styles: { textAlignment: 'center' },
						editable: false
					},
					this.gridService.getSelectionEditorColumn({ 
						name: "extrnlSrchKeyYn", fieldName: "extrnlSrchKeyYn", header : { text: this.text.extrnlSrchKeyYn, showTooltip: false } , 
						width: 80, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD),
					this.gridService.getSelectionEditorColumn({ 
						name: "bizRspsCdYn", fieldName: "bizRspsCdYn", header : { text: this.text.bizRspsCdYn, showTooltip: false } , 
						width: 80, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD)
				]);
				break;
			case 'ISOB':
				columns.push(...[
					{ 
						name: "iso8583SpecNo", fieldName: "iso8583SpecNo", header : { text: this.text.specNo, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' }, editable: false
					},
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583FldCharSetCd", fieldName: "iso8583FldCharSetCd", header : { text: this.text.fldCharSetCd, showTooltip: false } , 
						width: 80, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.ISO_FLD_CHARSET_CD),
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583VariableYn", fieldName: "iso8583VariableYn", header : { text: this.text.variableYn, showTooltip: false } , 
						width: 60, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD),
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583FldLenTypeCd", fieldName: "iso8583FldLenTypeCd", header : { text: this.text.fldLenTypeCd, showTooltip: false } , 
						width: 100, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.ISO_FLD_LEN_TYPE_CD),
					{ 
						name: "iso8583LenFldLen", fieldName: "iso8583LenFldLen", header : { text: this.text.fldLenLenCd, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' }, editable: false 
					},
					{ 
						name: "iso8583TrnsmsnDataLen", fieldName: "iso8583TrnsmsnDataLen", header : { text: this.text.trnsmsnDataLen, showTooltip: false } , 
						width: 100, styles: { textAlignment: 'center' }, 
						editable: false
					},
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583LenFldInclYn", fieldName: "iso8583LenFldInclYn", header : { text: this.text.lenFldInclYn, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD),
					this.gridService.getSelectionEditorColumn({ 
						name: "iso8583LenFldCopyYn", fieldName: "iso8583LenFldCopyYn", header : { text: this.text.lenFldCopyYn, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD),
					{ 
						name: "iso8583TagVal", fieldName: "iso8583TagVal", header : { text: this.text.tagVal, showTooltip: false } , 
						width: 120, styles: { textAlignment: 'center' } 
					},
					{ 
						name: "iso8583FldMaxLen", fieldName: "iso8583FldMaxLen", header : { text: this.text.fldMaxLen, showTooltip: false } , 
						width: 100, styles: { textAlignment: 'center' }, 
						editable: false
					},
					this.gridService.getSelectionEditorColumn({ 
						name: "extrnlSrchKeyYn", fieldName: "extrnlSrchKeyYn", header : { text: this.text.extrnlSrchKeyYn, showTooltip: false } , 
						width: 80, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD),
					this.gridService.getSelectionEditorColumn({ 
						name: "bizRspsCdYn", fieldName: "bizRspsCdYn", header : { text: this.text.bizRspsCdYn, showTooltip: false } , 
						width: 80, styles: { textAlignment: 'center' }, editable: false
					}, this.codes.YN_CD)
				]);
				break;
			case 'CH':
				if(this.data.chlDscd === 'EXTERNAL'){
					columns.push(...[
						this.gridService.getSelectionEditorColumn({ 
							name: "extrnlMsgNoYn", fieldName: "extrnlMsgNoYn", header : { text: this.text.extrnlMsgNoYn, showTooltip: false } , 
							width: 80, styles: { textAlignment: 'center' }, editable: false
						}, this.codes.YN_CD),
						this.gridService.getSelectionEditorColumn({ 
							name: "extrnlSrchKeyYn", fieldName: "extrnlSrchKeyYn", header : { text: this.text.extrnlSrchKeyYn, showTooltip: false } , 
							width: 80, styles: { textAlignment: 'center' }, editable: false
						}, this.codes.YN_CD),
						this.gridService.getSelectionEditorColumn({ 
							name: "bizRspsCdYn", fieldName: "bizRspsCdYn", header : { text: this.text.bizRspsCdYn, showTooltip: false } , 
							width: 80, styles: { textAlignment: 'center' }, editable: false
						}, this.codes.YN_CD)
					]);
				}
				break;
			case 'IV':
				if(this.data.chlDscd === 'EXTERNAL'){
					columns.push(...[
						this.gridService.getSelectionEditorColumn({ 
							name: "extrnlSrchKeyYn", fieldName: "extrnlSrchKeyYn", header : { text: this.text.extrnlSrchKeyYn, showTooltip: false } , 
							width: 80, styles: { textAlignment: 'center' }, editable: false
						}, this.codes.YN_CD),
						this.gridService.getSelectionEditorColumn({ 
							name: "bizRspsCdYn", fieldName: "bizRspsCdYn", header : { text: this.text.bizRspsCdYn, showTooltip: false } , 
							width: 80, styles: { textAlignment: 'center' }, editable: false
						}, this.codes.YN_CD)
					]);
				}
				break;
			}
		}

		return columns;
	}
	
	getMsgDetailGridData() {
		if(this.data.gridData) {
			this.displayMsgDetailGridData(this.data.gridData);
		}else{
			let encodedId = encodeURIComponent(this.data.msgLayoutId);
			
			this.httpService.get(`/msglayouts/${encodedId}`).then(res => {
				this.displayMsgDetailGridData(res);
			});
		}	
	}
	
	displayMsgDetailGridData(res) {
		const utilService = this.utilService;
		const { msglayoutdtDto: originRecords } = res;
		
		this.selectedMsg = utilService.clone(res);
		this._selectedMsg = utilService.clone(res);
		
		this.changeTransactionType();
		this.setApplicationCodeString();
		this.setRegDttm();
		
		this.detailDataProvider.setRows(originRecords.map(record => {
			record.fldUnqId = record.fldUnqId ? record.fldUnqId : this.utilService.uniqueId('TEMP_LAYOUT_DD_DTO_ID');
			return record;
		}));
					
		// 총길이
		this.calcLength();
	}
	
	setApplicationCodeString(){
		const selectedMsg = this.selectedMsg;
		
		if(_.isEmpty(selectedMsg)) return "";
		
		let lvCdsStr = `${selectedMsg.lv1Cd}/${selectedMsg.lv2Cd}/${selectedMsg.lv3Cd}`; 
		if(selectedMsg.lv4Cd) lvCdsStr += `/${selectedMsg.lv4Cd}`;
		selectedMsg.lvCdsStr = lvCdsStr;
	}
	
	setRegDttm(){
		const regDttm = this.selectedMsg.regDttm 
		if(regDttm) {
			const yy = regDttm.substring(0,4);
			const mm = regDttm.substring(4,6);
			const dd = regDttm.substring(6,8);
			const hh = regDttm.substring(8,10);
			const mi = regDttm.substring(10,12);
			const ss = regDttm.substring(12,14);
			this.selectedMsg.regDttmString = yy+"/"+mm+"/"+dd+"  "+hh+":"+mi+":"+ss;
		}
	}
	
	changeTransactionType(){
		if(_.isEmpty(this.selectedMsg)) {
			this.msgTypes = [];
			return;
		}
		
		switch(this.selectedMsg.chlDscd){
			case 'INTERNAL':
				switch(this.selectedMsg.trxDscd){
				case 'ONLINE':
					this.msgTypes = this.allMsgType.filter(v => v.cdVal == 'IV' || v.cdVal == 'CH' || v.cdVal == 'STH' );
					break;
				case 'BATCH':
					this.msgTypes = this.allMsgType.filter(v => v.cdVal == 'BATH' || v.cdVal == 'BATB' || v.cdVal == 'BATT' );
					break;
				}
				break;
			case 'EXTERNAL':
				switch(this.selectedMsg.trxDscd){
				case 'ONLINE':
					this.msgTypes = this.allMsgType.filter(v => v.cdVal == 'IV' || v.cdVal == 'CH' || v.cdVal == 'ISOH' || v.cdVal == 'ISOB');
					break;
				case 'BATCH':
					this.msgTypes = this.allMsgType.filter(v => v.cdVal == 'BATH' || v.cdVal == 'BATB' || v.cdVal == 'BATT' );
					break;
				}
				break;
		}
	}
	
	calcLength(){
		let gridRows = this.detailDataProvider.getJsonRows();
		let msgLen = 0;
		let layoutLength = [];
		let i;
		
		for (i = 0; i < gridRows.length; i++) {
			let row = gridRows[i];
			
			if(row.dataTypeNm == "LAYOUT"){
				var data = {};
				
				data.id = row.fldUnqId;
				
				if(row.arraySizeRefVal == undefined || isNaN(row.arraySizeRefVal)){
					data.msgLen = 1;		
					row.arraySizeRefVal = 1;
				}
				
				if(row.arraySizeRefVal != undefined && row.parentFldNm == undefined){
					data.msgLen = Number(row.arraySizeRefVal);
				}else{
					for (let j = 0; j < layoutLength.length; j++) {
						if(layoutLength[j].id == row.parentFldNm){
							data.msgLen = Number(row.arraySizeRefVal) * Number(layoutLength[j].msgLen);							
						}
					}
				}
				layoutLength.push(data);
				
			}
			
		}
		
		for (i = 0; i < gridRows.length; i++) {
			let row = gridRows[i];
			
			if(row.parentFldNm == undefined){
				msgLen += Number(row.msgLen);
			}else{		
				for (var j = 0; j < layoutLength.length; j++) {
					if(row.parentFldNm == layoutLength[j].id){						
						msgLen += Number(row.msgLen) * Number(layoutLength[j].msgLen);
					}
				}	
			}
		}
		
		this.msgLength = msgLen;
		
		return this.msgLength;
	}
	
	closeModal(isOk){
		if(isOk){
			this.$uibModalInstance.close();
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.detailGridView.destroy();
		this.detailDataProvider.destroy();
	}
	
	resizeGrid(){
		this.detailGridView && this.detailGridView.resetSize();  
	}
}

module(App.name).controller('SCR0704Controller', SCR0704Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0704/SCR0704.controller.js